import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Box, Checkbox, Stack, Typography } from '@mui/material';
import { CategoryOption } from 'components/forms/fields/category-autocomplete-field/category-autocomplete-base.component';
import { ReactNode } from 'react';

export enum AddProductCategoryEnum {
  MENU = 'MENU',
  GROUP = 'GROUP',
  ITEM = 'ITEM',
}

enum AddProductItemAttributeEnum {
  CATALOG = 'CATALOG',
  GROUP = 'GROUP',
  ITEM = 'ITEM',
}

enum ExcludeItemsEnum {
  EXCLUDE_MODIIFIERS = 'EXCLUDE_MODIIFIERS',
  EXCLUDE_ITEMS = 'EXCLUDE_ITEMS',
}

export type CategoryAutocompleteFieldOptionType = {
  attributeId: string;
  extAttributeId: string;
  itemAttribute: AddProductItemAttributeEnum;
  count: number;
  title: string;
  excludeTargets: ExcludeItemsEnum[];
} & CategoryOption;

type CategoryAutocompleteFieldOptionProps = {
  props: any;
  option: CategoryAutocompleteFieldOptionType;
  selected: boolean;
  allSelected: boolean;
  children: ReactNode;
};

const CategoryAutocompleteFieldOption = ({
  props,
  option,
  selected,
  allSelected,
  children,
}: CategoryAutocompleteFieldOptionProps) => {
  return (
    <li {...props} data-testid="Autocomplete.Option">
      <Stack direction="row">
        <Checkbox
          icon={<CheckBoxOutlineBlank fontSize="small" />}
          checkedIcon={<CheckBox fontSize="small" />}
          sx={{ mr: 0, alignSelf: 'flex-start' }}
          checked={option.id === 'ALL' ? allSelected : selected}
        />
        <Stack spacing={1} mt={1}>
          <Box>{option.label}</Box>
          {option.id !== 'ALL' && (
            <Typography variant="caption" color="text.disabled">
              {children}
            </Typography>
          )}
        </Stack>
      </Stack>
    </li>
  );
};

export default CategoryAutocompleteFieldOption;
